import { useCallback, useContext, useEffect, useState } from 'react';
import { TanqueContextC } from '../../contexts/contextTanque';
import {
  ModalAlert,
  ModalConfirmController,
  StyledModalVazao,
} from '../../styles/modals';
import { IoClose, IoNotificationsOutline } from 'react-icons/io5';
import { Bar, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import zoomPlugin from 'chartjs-plugin-zoom';
import { format } from 'date-fns';
import { GraficosTankes } from '../../styles/graficos';
import { RiCloseCircleFill } from 'react-icons/ri';
import Calendar from 'react-calendar';
import { PiCalendarBlankThin } from 'react-icons/pi';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { toast } from 'react-toastify';
import {
  classificarAlerta,
  formatarDataHoraAlerta,
  limparMensagemAlerta,
} from './formatarAlerta';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin,
  ChartDataLabels,
);

export const ModalAlertas = () => {
  const { setModalAlertas } = useContext(TanqueContextC);

  const { headerApi } = useContext(HomeContext);
  const [pageNumber, setPageNumber] = useState(1);

  const [alertas, setAlertas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const idUnidade = sessionStorage.getItem('connectionsUnitId');

  const listAlertasTanque = useCallback(async () => {
    try {
      setCarregando(true);
      const response = await apiJalles.get(`/alertas/tanque/Leitura/${idUnidade}`, headerApi);
      setAlertas(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setCarregando(false);
    }
  }, [headerApi, idUnidade]);

  const alterPage = async (url) => {
    try {
      setCarregando(true);
      const response = await apiJalles.get(
        `/alertas/tanque/Leitura/${idUnidade}/${url}`,
        headerApi,
      );

      setAlertas(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    listAlertasTanque();
  }, [listAlertasTanque]);

  return (
    <ModalAlert onClick={() => setModalAlertas(false)}>
      <section
        className="conteiner"
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-modal-alertas"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="headerModal">
          <div className="tituloModal">
            <span>Monitoramento dos tanques</span>
            <h2 id="titulo-modal-alertas">Histórico de alertas</h2>
            <p>{alertas.count ?? alertas.results?.length ?? 0} ocorrências registradas</p>
          </div>
          <button
            type="button"
            className="closeBotao"
            aria-label="Fechar histórico de alertas"
            onClick={() => setModalAlertas(false)}
          >
            <IoClose />
          </button>
        </header>

        <div className="legendaAlertas" aria-label="Legenda de criticidade">
          <span>
            <i className="critico" />Crítico
          </span>
          <span>
            <i className="atencao" />Atenção
          </span>
          <span>
            <i className="informativo" />Informativo
          </span>
        </div>

        <ul className="listaAlertas">
          {carregando && <li className="estadoLista">Carregando alertas...</li>}

          {!carregando && alertas.results?.length === 0 && (
            <li className="estadoLista">
              <IoNotificationsOutline />
              Nenhum alerta encontrado.
            </li>
          )}

          {!carregando &&
            alertas.results?.map((alerta, index) => {
              const { dia, hora } = formatarDataHoraAlerta(alerta.createdAt);
              const classificacao = classificarAlerta(alerta.mensagem);

              return (
                <li
                  key={alerta.id ?? `${alerta.createdAt}-${index}`}
                  className={`itemAlerta ${classificacao.tipo}`}
                >
                  <span className="alertaIndicador" />
                  <div className="alertaMensagem">
                    <div>
                      <span className="alertaTipo">{classificacao.rotulo}</span>
                      <time dateTime={alerta.createdAt}>
                        {dia} · {hora}
                      </time>
                    </div>
                    <strong>{limparMensagemAlerta(alerta.mensagem)}</strong>
                    <small>Registrado por {alerta.usuario?.nome || 'Sistema'}</small>
                  </div>
                </li>
              );
            })}
        </ul>

        <footer className="setasPaginacao">
          <button
            type="button"
            className={alertas.previous == null ? 'disable' : ''}
            disabled={alertas.previous == null || carregando}
            aria-label="Página anterior"
            onClick={() => {
              setPageNumber(pageNumber - 1);
              alterPage(alertas.previous);
            }}
          >
            <IoIosArrowBack />
            <span>Anterior</span>
          </button>
          <span className="paginaAtual">Página {pageNumber}</span>
          <button
            type="button"
            className={alertas.next == null ? 'disable' : ''}
            disabled={alertas.next == null || carregando}
            aria-label="Próxima página"
            onClick={() => {
              setPageNumber(pageNumber + 1);
              alterPage(alertas.next);
            }}
          >
            <span>Próxima</span>
            <IoIosArrowForward />
          </button>
        </footer>
      </section>
    </ModalAlert>
  );
};

export const ModalConfimacaoBombaTanque = ({ mensagem, validarComando }) => {
  const { setModalConfimationBomba, idControlerBomba } = useContext(TanqueContextC);

  const lidarButtonBomba = async (id) => {
    if (!validarComando(id)) {
      setModalConfimationBomba(false);
      return;
    }

    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const data = {
      comando: true,
    };

    try {
      await apiJalles.patch(`bomba/controle/${id}`, data, headerApi);
    } catch (error) {
      toast.error('Não foi possível enviar o comando para a bomba. Tente novamente.');
    } finally {
      setModalConfimationBomba(false);
    }
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja ${mensagem}`}</h2>
        <div>
          <button className="buttonYes" onClick={() => lidarButtonBomba(idControlerBomba)}>
            Sim
          </button>
          <button onClick={() => setModalConfimationBomba(false)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const GraficosTanquesC = ({ TanquesData }) => {
  // Extrair rótulos e níveis dos tanques dos dados fornecidos

  const tankLabels = (TanquesData || []).map((tank) => tank.nome_tanque);

  const tankLevels = (TanquesData || []).map((tank) => tank.nivel_atual);

  // Opções de zoom para o gráfico
  const zoomOptions = {
    pan: {
      enabled: true,
      mode: 'x',
    },
    zoom: {
      wheel: {
        enabled: true,
      },
      pinch: {
        enabled: true,
      },
      mode: 'x',
    },
  };

  // Configurações gerais do gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        display: false,
        labels: {
          color: '#e7e0e0', // Cor do texto do rótulo do conjunto de dados
          font: {
            size: 16, // Tamanho da fonte do texto do eixo y
          },
        },
      },
      title: {
        display: false,
      },
      datalabels: {
        display: true,

        formatter: (value) => `${value}%`,
        font: {
          size: 12,
          weight: 'bold',
        },
        color: '#ffffff',
      },
      zoom: zoomOptions,
    },

    scales: {
      x: {
        ticks: {
          color: '#bababa',
        },
        grid: {
          color: '#e0e0e01a',
          borderColor: '#d3d3d319',
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          color: '#979797',
        },
        grid: {
          color: '#e0e0e029',
          borderColor: '#d3d3d31f',
        },
      },
    },
  };

  // Estrutura de dados para o gráfico
  const data = {
    labels: tankLabels,
    datasets: [
      {
        label: 'Nível do Tanque',
        data: tankLevels,
        backgroundColor: 'rgba(157, 157, 157, 0.706)',
        borderColor: 'rgba(93, 93, 93, 0.559)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <GraficosTankes>
      <h2>Níveis dos Tanques</h2>
      <Bar options={options} data={data} />
    </GraficosTankes>
  );
};

export const GraficosByTanque = ({ TanqueDataId, TanqueNome }) => {
  const { headerApi } = useContext(HomeContext);
  const [historicoLabel, setHistoricoLabel] = useState([]);
  const [historicoData, setHistoricoData] = useState([]);
  const [calenderDate, setCalenderDate] = useState(new Date());
  const [dataAplicada, setDataAplicada] = useState(new Date());
  const [selectDate, setSelectDate] = useState('dia');
  const [modalCalender, setModalCalender] = useState(false);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);

  const listHistorico = useCallback(async () => {
    setHistoricoData([]);
    setModalCalender(false);
    try {
      setCarregandoHistorico(true);
      const formatData = format(dataAplicada, 'dd-MM-yyyy');

      const response = await apiJalles.get(
        `/historico/tanque/data/${TanqueDataId}/${formatData}/${selectDate}`,
        headerApi,
      );
      setHistoricoData(response.data);
      const newHistorico = response.data.map((historico) => {
        const date = new Date(historico.timestamp);
        const localDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));

        const dia = localDate.getDate().toString().padStart(2, '0');
        const mes = (localDate.getMonth() + 1).toString().padStart(2, '0');
        const ano = localDate.getFullYear();
        const hora = localDate.getHours().toString().padStart(2, '0');
        const minuto = localDate.getMinutes().toString().padStart(2, '0');

        const dataFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

        return dataFormatada;
      });

      setHistoricoLabel(newHistorico);
    } catch (error) {
      console.log(error);
    } finally {
      setCarregandoHistorico(false);
    }
  }, [TanqueDataId, dataAplicada, headerApi, selectDate]);

  useEffect(() => {
    listHistorico();
  }, [listHistorico]);

  // Opções de zoom para o gráfico
  const zoomOptions = {
    pan: {
      enabled: true,
      mode: 'x',
    },
    zoom: {
      wheel: {
        enabled: true,
      },
      pinch: {
        enabled: true,
      },
      mode: 'x',
    },
  };

  // Configurações gerais do gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest',
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'top',
        display: false,
        labels: {
          color: '#e7e0e0', // Cor do texto do rótulo do conjunto de dados
          font: {
            size: 16, // Tamanho da fonte do texto do eixo y
          },
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        backgroundColor: 'rgba(47, 61, 66, 0.96)',
        borderColor: 'rgba(205, 205, 205, 0.24)',
        borderWidth: 1,
        padding: 10,
        callbacks: {
          label: (context) => `Nível: ${context.parsed.y}%`,
        },
      },
      datalabels: {
        display: false,

        formatter: (value) => `${value}%`,
        font: {
          size: 12,
          weight: 'bold',
        },
        color: '#ffffff',
      },
      zoom: zoomOptions,
    },

    scales: {
      x: {
        ticks: {
          color: '#bababa',
          autoSkip: true,
          maxTicksLimit: 8,
          maxRotation: 0,
          callback: function (value) {
            const label = String(this.getLabelForValue(value) || '');
            const [dataLabel, horaLabel] = label.split(' ');

            if (selectDate === 'dia') return horaLabel || dataLabel;
            if (selectDate === 'mes') return dataLabel?.slice(0, 5);
            return dataLabel?.slice(3);
          },
        },
        grid: {
          display: true,
          color: 'rgba(224, 224, 224, 0.1)',
          borderColor: '#d3d3d319',
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          color: '#979797',
          stepSize: 10,
          callback: (value) => `${value}%`,
        },
        grid: {
          color: 'rgba(224, 224, 224, 0.1)',
          borderColor: '#d3d3d31f',
        },
      },
    },
  };

  const data = {
    labels: historicoLabel,
    datasets: [
      {
        label: 'Nível do Tanque',
        data: historicoData.map((historico) => {
          return historico.nivel_atual;
        }),
        backgroundColor: 'rgba(181, 181, 181, 0.1)',
        borderColor: 'rgba(221, 218, 216, 0.9)',
        borderWidth: 2,
        tension: 0.24,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHitRadius: 12,
        pointBackgroundColor: 'rgba(221, 218, 216, 0.96)',
      },
    ],
  };

  const formatoData = selectDate === 'ano' ? 'yyyy' : selectDate === 'mes' ? 'MM/yyyy' : 'dd/MM/yyyy';
  const dataExibicao = format(dataAplicada, formatoData);
  const fecharCalendario = () => {
    setCalenderDate(new Date(dataAplicada));
    setModalCalender(false);
  };

  return (
    <GraficosTankes className="graficoHistorico">
      <div className="headerHistorico">
        <div className="tituloHistorico">
          <span>Histórico de nível</span>
          <h2>{TanqueNome || 'Tanque selecionado'}</h2>
        </div>

        <div className="filtrosHistorico">
          <label className="filtroPeriodo" htmlFor="selectdate">
            <span>Período</span>
            <select
              name="selectdate"
              id="selectdate"
              value={selectDate}
              onChange={(e) => setSelectDate(e.target.value)}
            >
              <option value="dia">Dia</option>
              <option value="mes">Mês</option>
              <option value="ano">Ano</option>
            </select>
          </label>

          <button
            type="button"
            className="seletorData"
            onClick={() => setModalCalender(true)}
            aria-label="Selecionar data do histórico"
          >
            <PiCalendarBlankThin />
            <span>{dataExibicao}</span>
          </button>
        </div>
      </div>

      {modalCalender && (
        <div className="calendarDiv" onClick={fecharCalendario}>
          <div className="calendarioCard" onClick={(event) => event.stopPropagation()}>
            <header>
              <div>
                <span>Data do histórico</span>
                <h3>Selecione uma data</h3>
              </div>
              <button
                type="button"
                className="closeModal"
                aria-label="Fechar calendário"
                onClick={fecharCalendario}
              >
                <IoClose />
              </button>
            </header>
            <Calendar
              className="calendar"
              onChange={setCalenderDate}
              value={calenderDate}
              maxDate={new Date()}
            />
            <div className="buutons">
              <button
                type="button"
                className="acaoPrincipal"
                onClick={() => {
                  setDataAplicada(new Date(calenderDate));
                  setModalCalender(false);
                }}
              >
                Aplicar data
              </button>
              <button type="button" onClick={fecharCalendario}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="graficoCanvas">
        {carregandoHistorico && <div className="estadoHistorico">Carregando histórico...</div>}
        {!carregandoHistorico && historicoData.length === 0 && (
          <div className="estadoHistorico">
            <strong>Sem dados neste período</strong>
            <span>Escolha outra data para consultar.</span>
          </div>
        )}
        <Line options={options} data={data} />
      </div>
    </GraficosTankes>
  );
};

export const VazaoModal = ({ vazao, validarComando }) => {
  const { setModalVazao } = useContext(TanqueContextC);
  const [valor, setValor] = useState(vazao[1]);


  const lidarButtonBomba = async (id) => {
    if (!validarComando(id)) {
      setModalVazao(false);
      return;
    }

    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const data = {
      vazao: valor,
    };

    try {
      await apiJalles.patch(`bomba/controle/${id}`, data, headerApi);
      toast.success('Comando Feito com sucesso', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.error('Não foi possível alterar a vazão. Tente novamente.');
    } finally {
      setModalVazao(false);
    }
  };

  return (
    <StyledModalVazao>
      <div className="conteiner">
        <RiCloseCircleFill onClick={() => setModalVazao(false)} className="closeModal" />
        <h2>Controle de Vazão</h2>

        <div className="inpultDiv">
          <label>Vazão: {valor}%</label>
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            value={valor}
            onChange={(e) => setValor(Number(e.target.value))}
            className="inpulVazao"
          />
        </div>
        <button onClick={() => lidarButtonBomba(vazao[0])}>Enviar</button>
      </div>
    </StyledModalVazao>
  );
};
